<template>
  <RequestApproved
    request-type="leave"
    :notification="notification"
    :active-notification="activeNotification"
    @show-more-details="showMoreDetails"
  />
</template>

<script>
import RequestApproved from '@/components/notifications/RequestApproved'
import Notification from '@/components/notifications/mixins/Notification'

export default {
  name: 'LeaveRequestApproved',

  components: {
    RequestApproved,
  },

  mixins: [Notification],

  methods: {
    showMoreDetails() {
      this.$emit('click', this.notification)
    },
  },
}
</script>
